import {Component, NgZone, ViewChild} from '@angular/core';
import {AlertController, Content, IonicPage, NavController, NavParams} from 'ionic-angular';
import {AppDashboardPage} from "../app-dashboard/app-dashboard";
import {CourseQuizQuestion, CourseVideo} from "../../models/course-video";
import {AppVideoDetailsPage} from "../app-video-details/app-video-details";
import {UserProgressStateProvider} from "../../providers/user-progress-state/user-progress-state";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";

/**
 * Generated class for the AppVideoQuizPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-video-quiz',
  templateUrl: 'app-video-quiz.html',
})
export class AppVideoQuizPage {
  @ViewChild(Content) public content: Content;

  video: CourseVideo;
  question: CourseQuizQuestion;
  currentQuestion: number = 0;
  answers: Array<number>;
  errorVisible: boolean;
  currentAnswer: number = 0;
  answerStatus: number = 0;
  answerFeedback: string;


  constructor(public navCtrl: NavController, public navParams: NavParams, public progressProvider: UserProgressStateProvider, public ngZone: NgZone, public alertCtrl: AlertController, public contentTranslation: ContentTranslationProvider) {
    console.log('constructor AppVideoQuizPage', this.navParams.data);
    if(!this.navParams.data) {
      this.navCtrl.push(AppDashboardPage)
    }
    this.video = (this.navParams.data as CourseVideo);
    this.answers = [];
    this.question = this.video.quizQuestions[0];

    console.log(this.navParams.data);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppVideoQuizPage');

    this.currentAnswer = 0;
  }

  selectValue(val, event) {
    this.ngZone.run(() => {
      if(this.answers[this.currentQuestion] == val) {
        this.answers[this.currentQuestion] = null;
        this.currentAnswer = null;
      } else {
        this.answers[this.currentQuestion] = val;
        this.currentAnswer = val;
      }
    })
    this.errorVisible = false;
  }

  showResponseFeedback() {
    this.ngZone.run(() => {
      if (!this.answers[this.currentQuestion]) {
        let alert = this.alertCtrl.create({
          title: this.contentTranslation.translateContent('Error'),
          subTitle: this.contentTranslation.translateContent('Bitte wählen Sie eine der genannten Antworten aus.'),
          buttons: [
            {
              text: 'OK',
            },
            {
              text: '×',
              cssClass: 'close-button'
            }

          ],
          cssClass: 'ip-alert ip-with-close'
        });

        alert.present();

        return false;
      }

      let message = '';
      if(this.video.quizQuestions[this.currentQuestion].correctAnswer) {
        if (this.currentAnswer == this.video.quizQuestions[this.currentQuestion].correctAnswer.charCodeAt(0) - 64 && this.video.quizQuestions[this.currentQuestion].correctMessage) {
          this.answerStatus = 1;
          message = this.video.quizQuestions[this.currentQuestion].correctMessage;
        }
        if (this.currentAnswer != this.video.quizQuestions[this.currentQuestion].correctAnswer.charCodeAt(0) - 64 && this.video.quizQuestions[this.currentQuestion].incorrectMessage) {
          this.answerStatus = 2;
          message = this.video.quizQuestions[this.currentQuestion].incorrectMessage;
        }
      }

      this.content.scrollToTop();

      if(!message) {
        this.goNext();
      } else {
        this.answerFeedback = message;
      }

    });
  }

  goNext() {
    console.log(this.answers, 'click go next');
    this.ngZone.run(() => {
      if (!this.answers[this.currentQuestion]) {
        this.errorVisible = true;
        return false;
      }

      this.content.scrollToTop();

      this.answerFeedback = null;
      this.answerStatus = null;

      this.currentQuestion++;
      this.currentAnswer = null;

      this.question = this.video.quizQuestions[this.currentQuestion];

      if(!this.question) {
        if(this.progressProvider.currentProgress.video && this.progressProvider.currentProgress.video.id == this.video.id) {
          this.progressProvider.currentProgress.taskDone = true;
          this.progressProvider.triggerProgressUpdate();
        }
        if(this.video.type == 'plus') {
          this.video._userStatus = 3;
          this.progressProvider.triggerVideoPlusUpdate(this.video, 3)
        }
        this.goBackToCourse();
      }

    });
  }

  goBackToCourse() {
    this.navCtrl.pop();
  }

  reset() {
    this.currentQuestion = 0;
    this.answers = [];
    this.question = this.video.quizQuestions[0];
    this.currentAnswer = null;
  }
}



// WEBPACK FOOTER //
// ./src/pages/app-video-quiz/app-video-quiz.ts